import { toZonedTime, format } from "date-fns-tz";

export function convertUTCToIST(utcString) {
  const timeZone = "Asia/Kolkata";

  // Replace space with 'T' to make it ISO-compliant
  const isoString = utcString?.replace(" ", "T") + "Z";

  // Parse and convert
  const utcDate = new Date(isoString);
  const zonedDate = toZonedTime(utcDate, timeZone);

  // Format to 'yyyy-MM-dd HH:mm:ss'
  return format(zonedDate, "yyyy-MM-dd HH:mm", { timeZone });
}
